import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { clickedCardEvent } from '../../Utils/CategoryPageUtils';
import { removeDefaultParams } from '../../Utils/helper';
import {
  CategoryHyperlink,
  CategoryHyperLinkSection,
  MoreCategoryL2Title,
} from './L2Category/styled';

export default function MoreCategoriesSection(props) {
  const { subCategoriesData, bottomRef } = props;
  const router = useRouter();
  const section = {
    heading: 'Browse Related categories',
  };
  return subCategoriesData?.map((element, i) => {
    return (
      <CategoryHyperLinkSection ref={bottomRef} key={`cate_${i}`}>
        {element?.subCategories?.length > 0 && (
          <>
            <MoreCategoryL2Title>{element?.tabName}</MoreCategoryL2Title>
            <CategoryHyperlink>
              {element?.subCategories?.map((element, index) => {
                return element?.parentKey ? (
                  <Link
                    href={{
                      pathname: element?.parentKey,
                      query: removeDefaultParams(router.query),
                    }}
                    passHref
                    key={`hyperlink${index}${i}`}
                    locale={false}
                    onClick={() =>
                      clickedCardEvent(section, element, '', element?.parentKey)
                    }
                  >
                    {element?.tabName}
                  </Link>
                ) : null;
              })}
            </CategoryHyperlink>
          </>
        )}
      </CategoryHyperLinkSection>
    );
  });
}
